module.exports = __webpack_public_path__ + "img/IT.ad5e36cf.svg";